import React from 'react';
import ReactTable from "react-table";


function LeadGenProductsTable(props) {
    const columns = [
        {
            Header: "ASIN",
            accessor: "asin",
        },
        {
            Header: "Title",
            accessor: "title",
        },
        {
            Header: "Link",
            accessor: "link",
            Cell: cellInfo => <a
                className="mt-1"
                href={cellInfo.value}
                target="_blank"
                rel="noopener noreferrer"
            >
                View on Amazon
            </a>
        },
        {
            Header: "Categories",
            accessor: "categories",
        },
        {
            Header: "Rating",
            accessor: "rating",
        },
        {
            Header: "Ratings Total",
            accessor: "ratings_total",
        },
        {
            Header: "Sold by Amazon",
            accessor: "soldbyAmazon",
        },
        {
            Header: "Total Seller Count",
            accessor: "sellerCount",
        },
        {
            Header: "Monthly Sales Estimate",
            accessor: "monthly_sales_estimate",
        },
        {
            Header: "Weekly Sales Estimate",
            accessor: "weekly_sales_estimate",
        },
        {
            Header: "Bestseller Rank",
            accessor: "bestseller_rank",
        },
        {
            Header: "Sales Estimation Category",
            accessor: "sales_estimation_category",
        },
        {
            Header: "Message",
            accessor: "message",
        },
        
    ];


    return (
        <ReactTable
            columns={columns}
            data={props.data}
            style={{
                height: "400px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight -fixed"
            noDataText="No Data found."
        />
    )
}

export default LeadGenProductsTable;